import DiceAttribute, { DiceAttributeExport } from './diceAttribute';
import { Category } from '../character/allValues';
import { AttributeExportTypes } from './baseAttribute';

export interface ElementExport extends DiceAttributeExport {
  isProtection: boolean;
}

export default class ElementAttribute extends DiceAttribute {
  public isProtection = false;

  public constructor(name: string, isProtection: boolean) {
    super(name);
    this.isProtection = isProtection;
    if (this.isProtection) {
      this.abbreviation = this.generateAbbreviation(this.name + 'schutz');
      this.name = name + 'schutz';
    }
    this.category = Category.Element;
  }

  public export(): ElementExport {
    return {
      type: AttributeExportTypes.Element,
      abbreviation: this.abbreviation,
      isProtection: this.isProtection,
      dice: this.numDice,
      modifier: this.numBonus,
      name: this.name,
    };
  }

  public getClone() {
    let name = this.name;
    if (this.isProtection) {
      name = name.replace('schutz', '');
    }
    const clone = new ElementAttribute(name, this.isProtection);
    clone.numDice = this.numDice;
    clone.numBonus = this.numBonus;
    return clone;
  }
}
